import { CategoryNode } from 'src/screens/Sitemap/utils/buildCategoryTree'
import { CategoryItem } from 'src/screens/Sitemap/categoryItem'

interface CategoryTreeProps {
  categories: CategoryNode[]
  level?: number
}

export const CategoryTree = ({ categories, level = 0 }: CategoryTreeProps) => {
  if (categories.length === 0) return null

  return (
    <ul className={level === 0 ? 'list-none space-y-4' : 'list-none ml-8 mt-2 space-y-2'}>
      {categories.map(category => (
        <CategoryItem key={category.documentId} category={category} level={level} />
      ))}
    </ul>
  )
}
